module.exports = __webpack_public_path__ + "img/update.e34de369.svg";